
const digest = '5aecef568adfbdeca826893f9eac4e674682052ecf93d702b6aa5b405fe6b4ca';
const classes = {"wrapper":"_wrapper_1btpo_1"};
const css = `._wrapper_1btpo_1 {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #ebedf3;
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  